<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h3 class="h3">Welcome to Gomode adm!</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6">
                <info icone="fa-smile">
                    :)
                </info>
            </div>
        </div>
    </div>
</template>

<script>
import Info from "pedrociarlini-components/src/components/shared/painel/Info.vue";
export default {
    components: { Info },

    data() {
        return {};
    },
};
</script>

<style>
.centralizado {
    text-align: center;
}

.lista-fotos {
    list-style: none;
}
.lista-fotos .lista-fotos-item {
    display: inline-block;
}
table,
th,
td {
    border: 1px;
    border-style: solid;
    border-color: gray;
}
</style>
